import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {toast} from "react-toastify";
import {errorMsg} from "../../../../../Apis/functions";
import {INVITATION_REQUEST_DOCUMENTATION_DECISION_MODEL} from "../Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

/**
 * Custom hook for managing the state and logic of the general comment modal
 * used in the visitor invitation approval process.
 *
 * @param {string | number} row - The unique ID of the invitation being modified.
 * @param {function} setModified - Callback to notify the parent component that data was modified.
 * @param {string} status - Current status of the invitation (e.g., APPROVED, REJECTED).
 * @param {function} onHide - Callback to close or hide the modal.
 * @param {function} endPoint - Redux thunk action or API dispatcher to handle submission.
 *
 */
export const GeneralCommentRequestModalApp= ({row,setModified,status,onHide,endPoint}) =>{

    const [emptyFields, setEmptyFields] = useState(false);
    const [data, setData] = useState({...INVITATION_REQUEST_DOCUMENTATION_DECISION_MODEL});
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [infoParagraph, setInfoParagraph] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const resetValues = () =>{
        setData(prev => ({
            ...prev,
            statusReason: ''
        }));
    }

    const handleCreate = (STATUS) => {
        let option;
        let toastMessages;
        let statusReason = data?.statusReason;

        switch (STATUS) {
            case STATUS_MODEL.APPROVED:
                option = STATUS_MODEL.APPROVED;
                statusReason = 'approved'
                toastMessages =  t('has_been_created_successfully');
                break;
            case STATUS_MODEL.REJECTED:
                option = STATUS_MODEL.REJECTED;
                toastMessages =  t('has_been_denied_successfully');
                break;
            case STATUS_MODEL.CHANGES_REQUESTED:
                option = STATUS_MODEL.CHANGES_REQUESTED;
                toastMessages =  t('has_been_created_successfully');
                break;
            default:
                option = STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION;
                break;
        }
        let aux = {
            ...data,
            option : option,
            invitationId : row,
            statusReason: data?.statusReason ?? statusReason
        };

        if (status !== STATUS_MODEL.APPROVED && !data?.isValid()) {
            setEmptyFields(true);
            return;
        }

        const body = aux.toRegister();

        dispatch(endPoint(body)).then(
            ({ payload: { data: { success, code } } }) => {
                if (success) {
                    resetValues();
                    toast.success(toastMessages);
                    setModified(true)
                    onHide()
                } else {
                    errorMsg(code);
                }
            }
        );

        setEmptyFields(false);
    };

    useEffect(() => {
        switch (status) {
            case STATUS_MODEL.APPROVED:
                setInfoParagraph('you_can_leave_a_optional_comment');
                break;
            case STATUS_MODEL.REJECTED:
                setInfoParagraph('please_provide_a_reason');
                break;
            case STATUS_MODEL.CHANGES_REQUESTED:
                setInfoParagraph('please_described_changes');
                break;
            default:
                setInfoParagraph(STATUS_MODEL.PENDING_REVIEW);
                break;
        }
    }, [row, status])

    return {
        resetValues,
        emptyFields,
        handleChange,
        t,
        handleCreate,
        data,
        infoParagraph
    }
}
